export const API_ALL_CATEGORY =
  "https://cafe-notes-api.herokuapp.com/api/categories";
